export var MapServiceEvent = ['mapload', 'mapchange', 'mapAfterFrameChange'];
/**
 * 地图初始化配置项
 */